import { apiClient } from './client';

export interface RollResult {
  betId: number;
  roll: number;
  target: number;
  win: boolean;
  multiplier: number;
  amount: string;
  payout: string;
  newBalance: string;
  nonce: number;
  nextNonce: number;
  serverSeedHash: string;
  clientSeed: string;
  createdAt: string;
}

export interface PfActive {
  serverSeedHash: string;
  clientSeed: string;
  nonce: number;
}

export interface HistoryItem {
  betId: number;
  amount: string;
  payout: string;
  multiplier: string | null;
  nonce: number;
  result: { roll: number; target: number; win: boolean; multiplier: number };
  createdAt: string;
}

export interface BetDetail {
  betId: number;
  game: string;
  amount: string;
  payout: string;
  clientSeed: string;
  nonce: number;
  serverSeedHash: string;
  serverSeed: string | null;
  result: any;
  createdAt: string;
}

export interface RotateResult {
  revealed: { serverSeed: string; serverSeedHash: string; finalNonce: number };
  next: { serverSeedHash: string; nonce: number };
}

export const diceApi = {
  rollDice: (amount: string, target: number) =>
    apiClient.post<RollResult>('/dice/roll', { amount, target }).then((r) => r.data),
  history: (limit = 20) =>
    apiClient.get<HistoryItem[]>(`/dice/history?limit=${limit}`).then((r) => r.data),
  bet: (id: number) => apiClient.get<BetDetail>(`/dice/bets/${id}`).then((r) => r.data),
  pfActive: () => apiClient.get<PfActive>('/pf/active').then((r) => r.data),
  rotate: () => apiClient.post<RotateResult>('/pf/rotate').then((r) => r.data),
  setClientSeed: (clientSeed: string) =>
    apiClient.patch<PfActive>('/pf/client-seed', { clientSeed }).then((r) => r.data),
  balance: () => apiClient.get<{ amount: string }>('/ledger/balance').then((r) => r.data),
};

export const authApi = {
  login: (initData: string) =>
    apiClient.post('/auth/login', {}, { headers: { 'x-init-data': initData } }).then((r) => r.data),
  devLogin: (profileId?: string) =>
    apiClient.post('/auth/dev-login', { profileId }).then((r) => r.data),
};
